module.exports = {"520222001":"亦资街道","520222002":"翰林街道","520222003":"两河街道","520222004":"红果街道","520222005":"胜境街道","520222006":"刘官街道","520222104":"民主镇","520222105":"大山镇","520222106":"保田镇","520222109":"石桥镇","520222111":"响水镇","520222117":"柏果镇","520222121":"新民镇","520222123":"盘关镇","520222124":"竹海镇","520222125":"英武镇","520222126":"鸡场坪镇","520222127":"双凤镇","520222128":"丹霞镇","520222129":"乌蒙镇","520222202":"普田回族乡","520222208":"坪地彝族乡","520222210":"淤泥彝族乡","520222211":"普古彝族苗族乡","520222212":"旧营白族彝族苗族乡","520222213":"羊场布依族白族苗族乡","520222214":"保基苗族彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520222.json
// module id = 2593
// module chunks = 0